import { Injectable } from '@angular/core';
import { EntityState, EntityStore, StoreConfig } from '@datorama/akita';
import { TaskCm } from '../data/models';

export interface TaskState extends EntityState<TaskCm> {
  lockedEmployees: string[];
}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'task', resettable: true })
export class TaskStore extends EntityStore<TaskState> {
  constructor() {
    super({ lockedEmployees: [] });
  }
}
